import { render, staticRenderFns } from "./page.vue?vue&type=template&id=6a81cf02&scoped=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"
import style0 from "./page.vue?vue&type=style&index=0&id=6a81cf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81cf02",
  null
  
)

export default component.exports